import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const CopyIcon = ({ fill = '#1094F7', width = 12, height = 14 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 14"
        fill="none"
    >
        <path
            d="M9 2.86087L6.13912 0H1.6875C1.23995 0 0.810725 0.17779 0.494257 0.494257C0.17779 0.810725 0 1.23995 0 1.6875V11.25H9V2.86087ZM1.125 10.125V1.6875C1.125 1.53832 1.18426 1.39524 1.28975 1.28975C1.39524 1.18426 1.53832 1.125 1.6875 1.125H5.625V3.375H7.875V10.125H1.125ZM11.25 5.0625V13.5H2.8125V12.375H10.125V3.9375L11.25 5.0625Z"
            fill={fill}
        />
    </svg>
);
